import React, { Component } from 'react';

const DataBalance = ({message}) => {

    let response
    try {
        response = JSON.parse(message)
    }
    catch (e) {
        response = undefined
    }
    
    let total_quota,available_quota,pack_quota,prev_month_rollover
    if(response && response.length && response.length > 0 ){
        response.map(key=>{
            switch(key.tagName){
                case 'Total Quota : Available':
                    available_quota = key.informationDisplayValue
                    break;
                case 'Total Quota : Total':
                    total_quota =  key.informationDisplayValue
                    break;
                case 'Pack Quota : Total':
                    pack_quota = key.informationDisplayValue
                    break;
                case 'Previous Month Rollover Quota : Total':
                    prev_month_rollover = key.informationDisplayValue
                    break;
            }
        })
    }
    else{
        if(Object.keys(response) && Object.keys(response).length > 0){
            Object.keys(response).map((key)=>{
                switch(key){
                    case 'Total Quota : Available':
                        available_quota = response[key]
                        break;
                    case 'Total Quota : Total':
                        total_quota =  response[key]
                        break;
                    case 'Pack Quota : Total':
                        pack_quota = response[key]
                        break;
                    case 'Previous Month Rollover Quota':
                        prev_month_rollover = response[key]
                        break;
                }
            })
        }
    }


    // console.log({available_quota,total_quota,pack_quota,prev_month_rollover})
   let  percent  = available_quota && total_quota ? 100 - parseInt((available_quota.split(' ')[0]/total_quota.split(' ')[0])*100) : 0
    // let percent = 100 - parseInt((response['Total Quota : Available'].split(' ')[0]/response['Total Quota : Total'].split(' ')[0])*100)
    if(percent < 0){
        percent = 0
    }
    // TODO discuss when to show orange for data exhausted
    let data_exhausted = percent > 50
    return (
        <div>
        <div className=" mr-10  " style={{marginLeft:'60px',overflow:'auto'}}>
            <div className="rental-plan text-left pt-30 width-full pb-30 data_balance_new">
                <div className="plan-left-part width-50percent pull-left">
                    <div className={"progress-circle " + `p${ percent}` +  (percent > 50 ? ' over50 ' : '')}>
                        <div className="text color-white fs-20"><span>{available_quota && available_quota.split(' ')[0]}<span className="fs-10">{available_quota && available_quota.split(' ')[1]}</span></span><br />
                            <span className="fs-10">of {total_quota} left</span></div>
                        <div className="left-half-clipper">
                            <div className="first50-bar"/>
                            <div className="value-bar"/>
                        </div>
                    </div>
                </div>
                <div className="plan-right-part width-50percent pull-left">
                    <p className="fs-8 color-white">CURRENT PLAN DATA</p>
                    <p className="fs-20 color-white">{pack_quota && pack_quota.split(' ')[0]}<span className="fs-8">{pack_quota && pack_quota.split(' ')[1]}</span></p>

                    <p className="fs-8 color-white pt-20">PREVIOUS UNUSED DATA</p>
                    <p className="fs-20 color-white">{prev_month_rollover && prev_month_rollover.split(' ')[0]}<span className="fs-8">{prev_month_rollover && prev_month_rollover.split(' ')[1] && prev_month_rollover.split(' ')[1]}</span></p>

                </div>
            </div>
        </div>
        </div>

    );
}

export default DataBalance;


// WEBPACK FOOTER //
// ./src/components/message-components/data-balance.component.js